/**
 * `mailto:` hand-off — the email channel's `client_handoff`, used when the
 * caller has no connected mailbox to compose from in-app.
 */
export function buildContactMailtoUrl(
  email: string,
  opts?: { subject?: string; body?: string },
): string {
  const params = new URLSearchParams();
  if (opts?.subject) params.set('subject', opts.subject);
  if (opts?.body) params.set('body', opts.body);
  const query = params.toString();
  return query ? `mailto:${email}?${query}` : `mailto:${email}`;
}
